import { Component, OnInit } from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  Validators,
  AbstractControl,
  ValidationErrors,
} from "@angular/forms";
import {
  RiesgosVialesService,
  RiesgoVial,
} from "../../../../shared/services/riesgos-viales.service";
import { DataService } from "../../../../shared/services/municipios.service";
import {
  RolViaItem,
  RolViaService,
} from "../../../../shared/services/rol-via.service";
import { TipoRiesgoVialItem } from "../../../../shared/services/tipos-riesgo-vial.service";
import { TipoVehiculoService } from "../../../../shared/services/tipo-vehiculo.service";
import {
  RiesgosVialesCategoriaItem,
  RiesgosVialesCategoriasService,
  RiesgosVialesTipoItem,
} from "../../../../shared/services/riesgos-viales-categorias.service";
import {
  NivelExposicionPesvItem,
  NivelExposicionPesvService,
} from "../../../../shared/services/nivel-exposicion-pesv.service";
import {
  NivelProbabilidadPesvItem,
  NivelProbabilidadPesvService,
} from "../../../../shared/services/nivel-probabilidad-pesv.service";
import Swal from "sweetalert2";
import { Utils } from "../../../../shared/utils/Utils";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { Router } from "@angular/router";
import { TipoActorVialService } from "../../../../shared/services/tipo-actor-vial.service";
import {
  ApexAxisChartSeries,
  ApexChart,
  ApexDataLabels,
  ApexGrid,
  ApexLegend,
  ApexPlotOptions,
  ApexTooltip,
  ApexXAxis,
  ApexYAxis,
} from "ng-apexcharts";
import { TiposService } from "../../../../shared/services/tipos.service";

type RiesgosChartOptions = {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  xaxis: ApexXAxis;
  yaxis: ApexYAxis;
  dataLabels: ApexDataLabels;
  plotOptions: ApexPlotOptions;
  tooltip: ApexTooltip;
  grid: ApexGrid;
  legend: ApexLegend;
  colors: string[];
};

@Component({
  selector: "app-riesgos-viales",
  templateUrl: "./riesgos-viales.component.html",
  styleUrls: ["./riesgos-viales.component.scss"],
})
export class RiesgosVialesComponent implements OnInit {
  riesgos: RiesgoVial[] = [];
  riesgosFiltrados: RiesgoVial[] = [];
  form: FormGroup;
  cargando = false;
  guardando = false;
  editando: RiesgoVial | null = null;
  filtro: string = "";
  filtroEstado: number | null = null;
  ordenActorVial: "asc" | "desc" = "asc";
  tabActiva = 1;
  sortColumn: string = "";
  sortDirection: "asc" | "desc" = "asc";
  municipios: any[] = [];
  rolesVia: RolViaItem[] = [];
  categoriasRiesgoVial: RiesgosVialesCategoriaItem[] = [];
  tiposRiesgoVial: TipoRiesgoVialItem[] = [];
  tiposRiesgoVialFiltrados: TipoRiesgoVialItem[] = [];
  nivelesExposicion: NivelExposicionPesvItem[] = [];
  nivelesProbabilidad: NivelProbabilidadPesvItem[] = [];
  pageSize = 10;
  page = 1;
  maxFecha: string = "";
  consecutivo: any[] = [];
  listaActorvial: any;
  tiposVehiculo: any[] = [];
  totalRiesgosGrafico = 0;
  graficoRiesgosClasificacion: Partial<RiesgosChartOptions> =
    this.crearOpcionesGraficoClasificacion([], []);
  

  constructor(
    private riesgosService: RiesgosVialesService,
    private fb: FormBuilder,
    private dataService: DataService,
    private TipoVehiculoService: TipoVehiculoService,
    private riesgosVialesCategoriasService: RiesgosVialesCategoriasService,
    private nivelExposicionPesvService: NivelExposicionPesvService,
    private nivelProbabilidadPesvService: NivelProbabilidadPesvService,
    private router: Router,
    private modalService: NgbModal,
    private tipoActorVialService: TipoActorVialService,
    private tiposService: TiposService,
  ) {
    this.maxFecha = this.obtenerFechaHoy();
    this.form = this.fb.group({
      consecutivo: [{ value: "", disabled: true }], 
      proceso: ["", Validators.required],
      area: ["", Validators.required],
      actor_vial: [null, Validators.required],
      categoria_riesgo_vial: [null, Validators.required],
      tipo_riesgo: [null, Validators.required],
      descripcion: [""],
      actividad: [null, Validators.required],
      //origen: [null, [Validators.required]],
      //destino: [null, [Validators.required]],
     // fecha: ["", [Validators.required, this.validarFechaPasada.bind(this)]],
      nivel_exposicion: [null, [Validators.required]],
      nivel_probabilidad: [null, [Validators.required]],
      empleados_directos: [0, [Validators.required, Validators.min(0)]],
      //empleados_indirectos: [0, [Validators.required, Validators.min(0)]],
      empleados_misionales: [0, [Validators.required, Validators.min(0)]],
      contratistas: [0, [Validators.required, Validators.min(0)]],
      visitantes: [0, [Validators.required, Validators.min(0)]],
      tipo_vehiculo: [null, [Validators.required]],
      cantidadVehiculos: [0, [Validators.required, Validators.min(0)]],
    });
  }

  ngOnInit() {
    this.cargarRiesgos();
    this.cargarTiposVehiculo();
    this.cargarRolesVia();
    this.cargarCategoriasRiesgoVial();
    this.cargarNivelesExposicion();
    this.cargarNivelesProbabilidad();
    this.cargarGetNextRiesgoId();
  }
  cargarTiposVehiculo() {
     this.tiposService.getTipos().subscribe({
      next: (respuesta: any) => {
       // const lista = Array.isArray(respuesta)
        console.log("respuesta", respuesta);
       this.tiposVehiculo = Array.isArray(respuesta) ? respuesta : [];
      },
      error: () => {
        console.error("Error cargando tipos de vehículo para riesgos viales");
      }
     });
  }

  private obtenerFechaHoy(): string {
    const hoy = new Date();
    const año = hoy.getFullYear();
    const mes = String(hoy.getMonth() + 1).padStart(2, "0");
    const dia = String(hoy.getDate()).padStart(2, "0");
    return `${año}-${mes}-${dia}`;
  }

  private validarFechaPasada(
    control: AbstractControl,
  ): ValidationErrors | null {
    if (!control.value) {
      return null;
    }
    const fechaIngresada = new Date(control.value);
    const hoy = new Date();
    hoy.setHours(0, 0, 0, 0);
    fechaIngresada.setHours(0, 0, 0, 0);
    if (fechaIngresada > hoy) {
      return { fechaFutura: true };
    }
    return null;
  }

  private cargarCategoriasRiesgoVial(): void {
    this.riesgosVialesCategoriasService.getAll().subscribe({
      next: (respuesta: any) => {
        const lista = Array.isArray(respuesta)
          ? respuesta
          : Array.isArray(respuesta?.data)
            ? respuesta.data
            : [];

        this.categoriasRiesgoVial = lista
          .map((item: any) => ({
            id: Number(item?.id || 0),
            nombre_categoria: String(item?.nombre_categoria || "").trim(),
            estado: Number(item?.estado ?? 1),
            fechaCreacion: item?.fechaCreacion,
            fechaModificacion: item?.fechaModificacion,
            tiposRiesgoViales: Array.isArray(item?.tiposRiesgoViales)
              ? item.tiposRiesgoViales.map((tipo: any) => ({
                  id: Number(tipo?.id || 0),
                  descripcion: String(tipo?.descripcion || "").trim(),
                  id_categoria: Number(tipo?.id_categoria ?? item?.id ?? 0),
                  estado: Number(tipo?.estado ?? 1),
                  fechacreacion: tipo?.fechacreacion,
                  fechamodificacion: tipo?.fechamodificacion,
                }))
              : [],
          }))
          .filter(
            (item: RiesgosVialesCategoriaItem) =>
              !!item.id && !!item.nombre_categoria && item.estado === 1,
          )
          .sort(
            (a: RiesgosVialesCategoriaItem, b: RiesgosVialesCategoriaItem) =>
              String(a.nombre_categoria).localeCompare(
                String(b.nombre_categoria),
                "es",
                { sensitivity: "base" },
              ),
          );

        this.tiposRiesgoVial = this.categoriasRiesgoVial
          .flatMap((categoria) => categoria.tiposRiesgoViales || [])
          .filter(
            (item: RiesgosVialesTipoItem) =>
              !!item.id && !!item.descripcion && Number(item.estado ?? 1) === 1,
          )
          .map((item: RiesgosVialesTipoItem) => ({
            id: item.id,
            descripcion: item.descripcion,
            estado: item.estado,
            id_categoria: item.id_categoria,
            fechacreacion: item.fechacreacion,
            fechamodificacion: item.fechamodificacion,
          }));

        this.aplicarFiltroTiposRiesgo();
      },
      error: () => {
        this.categoriasRiesgoVial = [];
        this.tiposRiesgoVial = [];
        this.tiposRiesgoVialFiltrados = [];
      },
    });
  }

  aplicarFiltroTiposRiesgo(): void {
    const categoriaId = Number(
      this.form.get("categoria_riesgo_vial")?.value ?? 0,
    );
    const categoriaSeleccionada = this.categoriasRiesgoVial.find(
      (categoria) => Number(categoria.id) === categoriaId,
    );

    this.tiposRiesgoVialFiltrados = categoriaSeleccionada
      ? (categoriaSeleccionada.tiposRiesgoViales || [])
          .filter(
            (item: RiesgosVialesTipoItem) =>
              !!item.id && !!item.descripcion && Number(item.estado ?? 1) === 1,
          )
          .map((item: RiesgosVialesTipoItem) => ({
            id: item.id,
            descripcion: item.descripcion,
            id_categoria: item.id_categoria,
            estado: item.estado,
            fechacreacion: item.fechacreacion,
            fechamodificacion: item.fechamodificacion,
          }))
      : [];

    const tipoActual = this.form.get("tipo_riesgo")?.value;
    if (
      tipoActual &&
      !this.tiposRiesgoVialFiltrados.some(
        (item) => Number(item.id) === Number(tipoActual),
      )
    ) {
      this.form.patchValue({ tipo_riesgo: null });
    }
  }

  onCategoriaChange(): void {
    this.aplicarFiltroTiposRiesgo();
  }

  private cargarNivelesExposicion(): void {
    this.nivelExposicionPesvService.getAll().subscribe({
      next: (respuesta: any) => {
        const lista = Array.isArray(respuesta)
          ? respuesta
          : Array.isArray(respuesta?.data)
            ? respuesta.data
            : Array.isArray(respuesta?.nivelExposicion)
              ? respuesta.nivelExposicion
              : [];

        this.nivelesExposicion = lista
          .map((item: any) => ({
            id: Number(item?.id || 0),
            descripcion: String(item?.descripcion || "").trim(),
            estado: Number(item?.estado ?? 1),
            fechaCreacion: item?.fechaCreacion,
            fechaModificacion: item?.fechaModificacion,
          }))
          .filter(
            (item: NivelExposicionPesvItem) =>
              !!item.id && !!item.descripcion && Number(item.estado ?? 1) === 1,
          )
          .sort((a: NivelExposicionPesvItem, b: NivelExposicionPesvItem) =>
            String(a.descripcion).localeCompare(String(b.descripcion), "es", {
              sensitivity: "base",
            }),
          );
      },
      error: () => {
        this.nivelesExposicion = [];
      },
    });
  }

  private cargarNivelesProbabilidad(): void {
    this.nivelProbabilidadPesvService.getAll().subscribe({
      next: (respuesta: any) => {
        const lista = Array.isArray(respuesta)
          ? respuesta
          : Array.isArray(respuesta?.data)
            ? respuesta.data
            : Array.isArray(respuesta?.nivelProvabilidad)
              ? respuesta.nivelProvabilidad
              : [];

        this.nivelesProbabilidad = lista
          .map((item: any) => ({
            id: Number(item?.id || 0),
            descripcion: String(item?.descripcion || "").trim(),
            estado: Number(item?.estado ?? 1),
            fechaCreacion: item?.fechaCreacion,
            fechaModificacion: item?.fechaModificacion,
          }))
          .filter(
            (item: NivelProbabilidadPesvItem) =>
              !!item.id && !!item.descripcion && Number(item.estado ?? 1) === 1,
          )
          .sort((a: NivelProbabilidadPesvItem, b: NivelProbabilidadPesvItem) =>
            String(a.descripcion).localeCompare(String(b.descripcion), "es", {
              sensitivity: "base",
            }),
          );
      },
      error: () => {
        this.nivelesProbabilidad = [];
      },
    });
  }

  private cargarRolesVia(): void {
    
  /*   this.rolViaService.getAll().subscribe({      next: (respuesta: any) => {
        const lista = Array.isArray(respuesta)
          ? respuesta
          : Array.isArray(respuesta?.rolvia)
            ? respuesta.rolvia
            : Array.isArray(respuesta?.rolesVia)
              ? respuesta.rolesVia
              : [];

        this.rolesVia = lista
          .map((item: any) => ({
            idRolVia: Number(item?.idRolVia || item?.id || 0),
            descripcionRolVia: String(
              item?.descripcionRolVia || item?.descripcion || "",
            ).trim(),
            Estado: Number(item?.Estado ?? item?.estado ?? 1),
            fechaModifica: item?.fechaModifica,
          }))
          .filter(
            (item: RolViaItem) =>
              !!item.idRolVia && !!item.descripcionRolVia && item.Estado === 1,
          );
      },
      error: () => {
        this.rolesVia = [];
      },
    }); */
 this.tipoActorVialService.getTiposActorVialActivos().subscribe({
      next: (respuesta: any) => {
        //console.log("Tipos de actor vial activos:", respuesta);
        this.listaActorvial = respuesta;
        
      },
      error: () => {

      },
    });
  }

  private cargarMunicipios(): void {
    this.dataService.getDatos().subscribe({
      next: (data) => {
        this.municipios = Array.isArray(data) ? data : [];
      },
      error: (err) => {
        console.error("Error cargando municipios para riesgos viales:", err);
        this.municipios = [];
      },
    });
  }

  cargarRiesgos() {
    this.cargando = true;
    this.riesgosService.getAll().subscribe({
      next: (data) => {
        this.riesgos = (Array.isArray(data) ? data : []).map((item: any) => ({
          ...item,
          nivel_probabilidad:
            Number(item?.nivel_probabilidad ?? item?.nivel_deficiencia ?? 0) ||
            0,
        }));
        this.aplicarFiltro();
        this.cargando = false;
      },
      error: () => {
        this.cargando = false;
      },
    });
  }

  cargarGetNextRiesgoId(): void {
  this.cargando = true;

  this.riesgosService.getNextRiesgoId().subscribe({
    next: (response) => {
      this.consecutivo = response.consecutivo;

      // Si tienes un campo en el formulario
      this.form.patchValue({
        consecutivo: response.consecutivo
      });

      this.cargando = false;
    },
    error: () => {
      this.cargando = false;
    }
  });
}

  aplicarFiltro(): void {
    const termino = (this.filtro || "").trim().toLowerCase();
    this.riesgosFiltrados = this.riesgos
      .filter((r) => {
        const coincideEstado =
          this.filtroEstado === null || r.estado === this.filtroEstado;
        const actorVialTexto = this.getActorVialLabel(r.actor_vial);
        const tipoRiesgoTexto = this.getTipoRiesgoLabel(r.tipo_riesgo);
        const coincideBusqueda =
          String(r.actor_vial || "")
            .toLowerCase()
            .includes(termino) ||
          actorVialTexto.toLowerCase().includes(termino) ||
          String(r.tipo_riesgo || "")
            .toLowerCase()
            .includes(termino) ||
          tipoRiesgoTexto.toLowerCase().includes(termino) ||
          String(r.actividad || "")
            .toLowerCase()
            .includes(termino) ||
          String(r.descripcion || "")
            .toLowerCase()
            .includes(termino) ||
          String((r as any).descripcion_exposicion || "")
            .toLowerCase()
            .includes(termino) ||
          String((r as any).descripcion_probabilidad || "")
            .toLowerCase()
            .includes(termino) ||
          String(r.nivel_exposicion || "")
            .toLowerCase()
            .includes(termino) ||
          String(r.nivel_probabilidad || "")
            .toLowerCase()
            .includes(termino);
        return coincideEstado && coincideBusqueda;
      })
      .sort((a, b) => {
        const comparacion = String(a.actor_vial || "").localeCompare(
          String(b.actor_vial || ""),
          "es",
          { sensitivity: "base" },
        );

        return this.ordenActorVial === "asc" ? comparacion : -comparacion;
      });
    this.actualizarGraficoRiesgos();
    this.page = 1;
  }

  private actualizarGraficoRiesgos(): void {
    const fuente = this.riesgosFiltrados || [];
    this.totalRiesgosGrafico = fuente.length;

    if (!fuente.length) {
      this.graficoRiesgosClasificacion = this.crearOpcionesGraficoClasificacion(
        [],
        [],
      );
      return;
    }

    const conteoPorClasificacion = fuente.reduce(
      (acumulado: Record<string, number>, riesgo: any) => {
        const nombreClasificacion = this.normalizarClasificacion(
          riesgo?.clasificacion,
        );
        acumulado[nombreClasificacion] =
          (acumulado[nombreClasificacion] || 0) + 1;
        return acumulado;
      },
      {},
    );

    const etiquetas = Object.keys(conteoPorClasificacion);
    const valores = etiquetas.map((etiqueta) => conteoPorClasificacion[etiqueta]);

    this.graficoRiesgosClasificacion = this.crearOpcionesGraficoClasificacion(
      etiquetas,
      valores,
    );
  }

  private normalizarClasificacion(valor: any): string {
    const texto = String(valor || "").trim().toUpperCase();
    return texto || "SIN CLASIFICACION";
  }

  private crearOpcionesGraficoClasificacion(
    categorias: string[],
    data: number[],
  ): Partial<RiesgosChartOptions> {
    return {
      series: [
        {
          name: "Riesgos",
          data,
        },
      ],
      chart: {
        type: "bar",
        height: 340,
        toolbar: {
          show: false,
        },
      },
      plotOptions: {
        bar: {
          horizontal: true,
          borderRadius: 6,
          distributed: true,
          dataLabels: {
            position: "top",
          },
          barHeight: "58%",
        },
      },
      colors: ["#1f77b4", "#ff7f0e", "#2ca02c", "#d62728", "#8c564b"],
      dataLabels: {
        enabled: true,
        formatter: (value: number) => `${value}`,
        style: {
          fontSize: "12px",
          fontWeight: "600",
          colors: ["#1f2937"],
        },
        offsetX: 12,
      },
      xaxis: {
        categories: categorias,
        title: {
          text: "Cantidad de riesgos",
        },
      },
      yaxis: {
        title: {
          text: "Clasificacion",
        },
      },
      grid: {
        borderColor: "#edf1f7",
        strokeDashArray: 4,
      },
      legend: {
        show: false,
      },
      tooltip: {
        y: {
          formatter: (value: number) => {
            const porcentaje = this.totalRiesgosGrafico
              ? ((value / this.totalRiesgosGrafico) * 100).toFixed(1)
              : "0.0";
            return `${value} riesgos (${porcentaje}%)`;
          },
        },
      },
    };
  }

  alternarOrdenActorVial(): void {
    // legacy - kept for compatibility, redirect to general sorter
    this.sortData("actor_vial");
  }

  sortData(column: string) {
    if (this.sortColumn === column) {
      this.sortDirection = this.sortDirection === "asc" ? "desc" : "asc";
    } else {
      this.sortColumn = column;
      this.sortDirection = "asc";
    }

    const listToSort = this.riesgosFiltrados.length
      ? this.riesgosFiltrados
      : this.riesgos;

    listToSort.sort((a, b) => {
      let aVal = this.getSortValue(a, column);
      let bVal = this.getSortValue(b, column);

      if (typeof aVal === "string") aVal = aVal.toLowerCase();
      if (typeof bVal === "string") bVal = bVal.toLowerCase();

      if (aVal < bVal) return this.sortDirection === "asc" ? -1 : 1;
      if (aVal > bVal) return this.sortDirection === "asc" ? 1 : -1;
      return 0;
    });

    this.page = 1;
  }

  private getSortValue(item: any, column: string): any {
    if (column === "actor_vial") {
      return this.getActorVialLabel(item?.actor_vial);
    }

    if (column === "tipo_riesgo") {
      return this.getTipoRiesgoLabel(item?.tipo_riesgo);
    }

    return this.getNestedValue(item, column);
  }

  getNestedValue(obj: any, path: string): any {
    return path.split(".").reduce((acc, part) => acc && acc[part], obj) ?? "";
  }

  getActorVialLabel(value: any): string {
    const actorId = Number(value ?? 0);
    const actor = this.rolesVia.find(
      (item) => Number(item.idRolVia) === actorId,
    );
    return actor?.descripcionRolVia || String(value ?? "");
  }

  getTipoRiesgoLabel(value: any): string {
    const tipoId = Number(value ?? 0);
    const tipo = this.tiposRiesgoVial.find(
      (item) => Number(item.id) === tipoId,
    );
    return tipo?.descripcion || String(value ?? "");
  }

  private resolveActorVialId(value: any): number | null {
    const actorId = Number(value ?? 0);
    if (actorId > 0) {
      return actorId;
    }

    const actor = this.rolesVia.find(
      (item) =>
        String(item.descripcionRolVia || "").toLowerCase() ===
        String(value || "").toLowerCase(),
    );
    return actor ? Number(actor.idRolVia) : null;
  }

  private resolveTipoRiesgoId(value: any): number | null {
    const tipoId = Number(value ?? 0);
    if (tipoId > 0) {
      return tipoId;
    }

    const tipo = this.tiposRiesgoVial.find(
      (item) =>
        String(item.descripcion || "").toLowerCase() ===
        String(value || "").toLowerCase(),
    );
    return tipo ? Number(tipo.id) : null;
  }

  private resolveCategoriaRiesgoId(riesgo: any): number | null {
    const categoriaId = Number(
      riesgo?.categoria_vial ??
        riesgo?.categoria_riesgo_vial ??
        riesgo?.categoria_id ??
        riesgo?.id_categoria ??
        riesgo?.categoriaData?.id ??
        0,
    );
    return categoriaId > 0 ? categoriaId : null;
  }

  guardar() {
    if (this.form.invalid) return;
    this.guardando = true;
    const { categoria_riesgo_vial, consecutivo, ...restoFormulario } = this.form.getRawValue();
    const data = {
      ...restoFormulario,
      consecutivo: consecutivo ?? this.consecutivo,
      categoria_vial: Number(categoria_riesgo_vial ?? 0),
      actor_vial: Number(restoFormulario?.actor_vial ?? 0),
      tipo_riesgo: Number(restoFormulario?.tipo_riesgo ?? 0),
      actividad:
        restoFormulario?.actividad === "NO RUTINARIA"
          ? "NO_RUTINARIA"
          : restoFormulario?.actividad,
      nivel_exposicion: Number(restoFormulario?.nivel_exposicion ?? 0),
      nivel_probabilidad: Number(restoFormulario?.nivel_probabilidad ?? 0),
    };
    console.log("Datos a guardar:", data);
    if (this.editando) {
      this.riesgosService.update(this.editando.id!, data).subscribe({
        next: () => {
          this.cargarRiesgos();
          this.cancelar();
          Swal.fire(
            "Éxito",
            "Riesgo vial actualizado correctamente.",
            "success",
          );
        },
        error: () => {
          Swal.fire("Error", "No se pudo actualizar el riesgo vial.", "error");
        },
        complete: () => {
          this.guardando = false;
        },
      });
    } else {
      this.riesgosService.create(data).subscribe({
        next: () => {
          this.cargarRiesgos();
          this.form.reset({ actividad: "RUTINARIA" });
          Swal.fire("Éxito", "Riesgo vial guardado correctamente.", "success");
        },
        error: () => {
          Swal.fire("Error", "No se pudo guardar el riesgo vial.", "error");
        },
        complete: () => {
          this.guardando = false;
        },
      });
    }
  }

  editar(riesgo: RiesgoVial, modalRef: any) {
    if (riesgo.estado !== 1) return;
    const categoriaId = this.resolveCategoriaRiesgoId(riesgo);

    this.editando = riesgo;
    this.form.patchValue({
      ...riesgo,
      actor_vial: this.resolveActorVialId((riesgo as any)?.actor_vial),
      categoria_riesgo_vial: categoriaId,
      tipo_riesgo: this.resolveTipoRiesgoId((riesgo as any)?.tipo_riesgo),
      actividad:
        riesgo.actividad === "NO_RUTINARIA" ? "NO_RUTINARIA" : riesgo.actividad,
      nivel_exposicion: Number((riesgo as any)?.nivel_exposicion ?? 0) || null,
      nivel_probabilidad:
        Number(
          (riesgo as any)?.nivel_probabilidad ??
            (riesgo as any)?.nivel_deficiencia ??
            0,
        ) || null,
    });
    this.aplicarFiltroTiposRiesgo();
    this.modalService.open(modalRef, {
      size: "xl",
      centered: true,
      backdrop: "static",
    });
  }

  cerrarModal(modal: any) {
    modal.close();
    this.cancelar();
  }

  eliminar(id: number) {
    Swal.fire({
      title: "¿Inactivar riesgo vial?",
      text: "¿Está seguro de que desea inactivar este riesgo vial?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Sí, inactivar",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (result.isConfirmed) {
        this.riesgosService.inactivar(id).subscribe({
          next: () => {
            this.cargarRiesgos();
            Swal.fire(
              "Éxito",
              "Riesgo vial inactivado correctamente.",
              "success",
            );
          },
          error: () => {
            Swal.fire("Error", "No se pudo inactivar el riesgo vial.", "error");
          },
        });
      }
    });
  }

  activar(id: number) {
    Swal.fire({
      title: "¿Activar riesgo vial?",
      text: "¿Está seguro de que desea activar este riesgo vial?",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Sí, activar",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (result.isConfirmed) {
        this.riesgosService.activar(id).subscribe({
          next: () => {
            this.cargarRiesgos();
            Swal.fire(
              "Éxito",
              "Riesgo vial activado correctamente.",
              "success",
            );
          },
          error: () => {
            Swal.fire("Error", "No se pudo activar el riesgo vial.", "error");
          },
        });
      }
    });
  }

  cancelar() {
    this.editando = null;
    this.form.reset({ actividad: "RUTINARIA" });
    this.tiposRiesgoVialFiltrados = [...this.tiposRiesgoVial];
  }

  // Igual que en listado de personas: firma y nombres iguales
  exportToPDF(tableId: string, nameFile: string, titleFile: string) {
    Utils.exportToPDF(tableId, nameFile, titleFile);
  }

  exportarExcel(tableId: string, nameFile: string) {
    Utils.exportVisibleTableToExcel(tableId, nameFile);
  }

  CrearPlanAccion(RiesgoVial: RiesgoVial): void {
 //   console.log("Crear plan de acción para el riesgo vial:", RiesgoVial);
  Swal.fire({
    title: "Crear plan de acción",
    text: `¿Desea crear un plan de acción para el riesgo vial con ID: ${RiesgoVial}?`,
    icon: "question",
    showCancelButton: true,
    confirmButtonText: "Sí, Ver",
    cancelButtonText: "Cancelar"
  }).then((result) => {
    if (result.isConfirmed) {

      this.router.navigate(['riesgo-vial/plan-accion', RiesgoVial]);
    }
  });
}

editarRiesgo(riesgo: RiesgoVial): void {
  console.log("Editar riesgo vial:", riesgo);
  this.tabActiva = 1; // Cambiar a la pestaña de edición
  this.editando = riesgo;

  const categoriaId = this.resolveCategoriaRiesgoId(riesgo);

  this.form.patchValue({
    ...riesgo,
    actor_vial: this.resolveActorVialId((riesgo as any)?.actor_vial),
    categoria_riesgo_vial: categoriaId,
    tipo_riesgo: this.resolveTipoRiesgoId((riesgo as any)?.tipo_riesgo),
    actividad:
      riesgo.actividad === "NO_RUTINARIA" ? "NO_RUTINARIA" : riesgo.actividad,
    nivel_exposicion: Number((riesgo as any)?.nivel_exposicion ?? 0) || null,
    nivel_probabilidad:
      Number(
        (riesgo as any)?.nivel_probabilidad ??
          (riesgo as any)?.nivel_deficiencia ??
          0,
      ) || null,
  });

  this.aplicarFiltroTiposRiesgo();
}
}